import { render } from "./Loyalty.vue?vue&type=template&id=73d2cf71&scoped=true"
import script from "./Loyalty.vue?vue&type=script&lang=js"
export * from "./Loyalty.vue?vue&type=script&lang=js"

import "./Loyalty.vue?vue&type=style&index=0&id=73d2cf71&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d2cf71"]])

export default __exports__